(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatie-signup-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('signup-dialog');
  if (!dialog) return;
  const form = document.getElementById('popup-form');
  const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key,value) => { try { localStorage.setItem(key,value); } catch {} };
  const pendingKey = 'tatie-popup-pending';
  let pending = false;
  try { pending = sessionStorage.getItem(pendingKey) === '1'; } catch {}
  const success = document.getElementById('popup-success');
  const errors = document.getElementById('popup-errors');
  let timer;
  let submitting = false;
  const open = () => { if (!dialog.open) dialog.showModal(); };
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    if (!submitting) write('tatie-popup-dismiss-until',String(Date.now() + Number(dialog.dataset.dismissDays) * 86400000));
  });
  dialog.querySelector('.close-dialog').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  const prepareSubmission = () => {
    if (!form.checkValidity()) return;
    submitting = true;
    try { sessionStorage.setItem(pendingKey,'1'); } catch {}
    setTimeout(() => { if (dialog.open) dialog.close(); },0);
  };
  form.addEventListener('submit', prepareSubmission, true);
  form.querySelector('button[type=submit]')?.addEventListener('click', prepareSubmission);
  form.addEventListener('keydown', (event) => { if (event.key === 'Enter' && event.target.matches('input')) prepareSubmission(); });
  document.querySelectorAll('a[href="#newsletter"]').forEach(link => link.addEventListener('click', (event) => {
    event.preventDefault();
    clearTimeout(timer);
    submitting = false;
    open();
  }));
  if (success) {
    write('tatie-newsletter-subscribed','1');
    open();
    success.focus();
    try { sessionStorage.removeItem(pendingKey); } catch {}
    return;
  }
  if (errors) { open(); errors.focus(); return; }
  if (dialog.dataset.subscribed === 'true' || read('tatie-newsletter-subscribed') === '1' || Number(read('tatie-popup-dismiss-until')) > Date.now()) return;
  const attempt = () => {
    if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,button') || document.querySelector('#main-nav.open')) { timer = setTimeout(attempt,3000); return; }
    open();
  };
  timer = setTimeout(attempt,Number(dialog.dataset.delay) * 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
